import { SizeConfig } from "./types";

/** Size configurations for each variant */
export const SIZE_CONFIGS: Record<"default" | "small" | "compact", SizeConfig> =
  {
    default: {
      borderWidth: "3px",
      borderRadius: "20px",
      padding: "30px",
      minHeight: "170px",
      iconSize: 40,
      titleSize: "16px",
      subtitleSize: "14px",
      hintSize: "12px",
    },
    small: {
      borderWidth: "3px",
      borderRadius: "16px",
      padding: "20px",
      minHeight: "120px",
      iconSize: 32,
      titleSize: "14px",
      subtitleSize: "13px",
      hintSize: "11px",
    },
    compact: {
      borderWidth: "2px",
      borderRadius: "12px",
      padding: "16px",
      minHeight: "100px",
      iconSize: 24,
      titleSize: "13px",
      subtitleSize: "12px",
      hintSize: "11px",
    },
  };
